import type { LoaderFunctionArgs } from 'react-router';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import ROUTES from '@/routes';
import { queryClient } from '@/utils/query-client';

export async function groupMembersLoader({ params }: LoaderFunctionArgs) {
  const { id: groupId } = ROUTES.MESSAGES.GROUPS.SETTINGS.MEMBERS.$deserializeParams(params);

  await queryClient.invalidateQueries(generateGroupInfoQueryOptions(groupId));
}
